/* ===========================================================================
   EUPHORIA · LANGUAGE SWITCH                         assets/euphoria-lang.js
   The header switch is a <details> menu listing both languages. With only two
   languages that is one tap too many, and the button is now labelled with the
   language you GET ("English" / "ENG"), so opening a menu to pick that same
   language reads oddly. This turns the button into a direct switch.

   It submits the theme's own {% form 'localization' %} — the same request the
   menu item would have sent — so Shopify handles the redirect and remembers
   the choice. If this script fails to load, the menu still works as before.
   =========================================================================== */
(function () {
  'use strict';

  function wire(dd, target) {
    if (dd.dataset.euLang === '1') { return; }
    var summary = dd.querySelector('summary');
    if (!summary) { return; }

    dd.dataset.euLang = '1';
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-label', target.textContent.trim());

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      dd.open = false;
      target.click();
    });
  }

  function init() {
    /* The country selector shares .eh-dd, so match on the locale buttons
       rather than on position. Only collapse the menu when there is exactly
       one other language to switch to. */
    var dds = document.querySelectorAll('.eh-locale .eh-dd');
    for (var i = 0; i < dds.length; i++) {
      var options = dds[i].querySelectorAll('.eh-dd__opt[name="locale_code"]');
      if (options.length !== 2) { continue; }
      var target = null;
      for (var j = 0; j < options.length; j++) {
        if (!options[j].classList.contains('is-active')) { target = options[j]; }
      }
      if (target) { wire(dds[i], target); }
    }
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();